:host {
  display: block;
  @include cms-base-font-100;
}

details>summary {
  list-style: none;
  align-items: center;
  cursor: pointer;
  outline: 0;
  position: relative;
  padding: var(--cms-spacing-075) var(--cms-spacing-100);
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  background: var(--cms-semanticColors-transparency-strong-background);
  font-family: var(--cms-brandfont2), serif;
  font-size: var(--cms-font-size-112);
  line-height: var(--cms-line-height-120);
  font-weight: var(--cms-heading-base-font-weight);
}

details>summary:hover,
details[open='true']>summary:hover {
  background: var(--cms-theme-strong-hover);
}

details>summary:active,
details[open='true']>summary:active {
  background: var(--cms-theme-strong-active-background);
}

details>summary:focus,
details[open='true']>summary:focus {
  box-shadow: 0 0 0 var(--cms-spacing-025) var(--cms-theme-focus-outline);
}

details[open='true']>summary {
  background: var(--cms-theme-strong-active-background);
}

details>summary::-webkit-details-marker {
  display: none;
}

.accordion-details {
  height: auto;
  border: var(--cms-border-size-xs) solid var(--cms-theme-border-color);
  overflow: hidden;
  transition: height 300ms ease-in-out;
  margin-bottom: var(--cms-spacing-075);
}

.accordion-content p:empty:has(+ ul),
.accordion-content p:empty:has(+ ol),
.accordion-content ol+p:empty,
.accordion-content ul+p:empty {
  display: none;
}

.accordion-headline {
  padding-right: var(--cms-spacing-050);
  color: var(--cms-theme-text-color);
}

.svg-icon-wrapper {
  display: flex;
  align-items: center;
}

.accordion-content {
  display: block;
}

.accordion-details-content {
  padding-top: var(--cms-spacing-100);
}